var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { customElement, property, css, html, LitElement } from 'lit-element';
let TcModal = class TcModal extends LitElement {
    constructor() {
        super();
        this.title = '';
        this.size = 'auto';
        this.callback = '';
        this.visible = false;
        this.cannotBeClosed = false;
        this.hideCloseButton = false;
        this.hideHeader = false;
        this.overflow = 'auto';
        this.height = '';
        // Przypisanie zamykania modala do wszystkich elementów z atrybutem modal-close w ramach slotu
        this.querySelectorAll('[modal-close]').forEach((elem) => {
            elem.addEventListener('click', (e) => {
                e.preventDefault();
                this.close();
            });
        });
    }
    firstUpdated() {
        // Wykonanie callbacku, jeżeli podano
        if (this.callback.length > 0) {
            eval(`
                const callback = ${this.callback}
                callback();
            `);
        }
        // Wywołanie obsługi otwarcia, jeżeli komponent został od razu utworzony z atrybutem visible
        if (this.visible) {
            this.open();
        }
    }
    static get styles() {
        return css `
            .modal {
                min-width: 318px;
                background: #fff;
                height: auto;
                max-width: 100vh;
                position: fixed;
                left: 50%;
                top: 50%;
                transform: translate(-50%, -50%);
                box-shadow: 0 0 10px rgba(0, 0, 0, 0.5);
                border-radius: 5px;
                box-sizing: border-box;
                z-index: 100;
                max-height: 100dvh;
                overflow: auto;
            }
            @media (min-width: 1262px) {
                .modal {
                    max-width: 1248px;
                }
            }
            .modal.size-medium {
                width: 100%;
                max-width: 800px;
            }
            .modal.size-large {
                width: 100%;
                max-width: 1248px;
            }
            .modal.overflow-auto {
                overflow: auto;
            }
            .modal.overflow-initial {
                overflow: initial;
            }
            .modal.overflow-initial .header {
                overflow: hidden;
            }

            @media (max-width: 960px) {
                .modal.height-mobile-full {
                    height: 90vh;
                }
            }

            .overlay {
                position: fixed;
                z-index: 99;
                left: 0;
                top: 0;
                width: 100%;
                height: 100%;
                background: rgba(0, 0, 0, 0.3);
            }
            .header {
                color: var(--color-primary);
                background-color: rgb(243, 244, 232);
                display: flex;
                align-items: center;
                justify-content: space-between;
                padding: 1rem;
                box-sizing: border-box;
                min-width: 100%;
                font-weight: bold;
                font-size: 1.571rem;
                background-repeat: no-repeat;
                background-position: 50px 50%;
                min-height: 2.5em;
                border-top-left-radius: 0.5em;
                border-top-right-radius: 0.5em;
            }
            .header > span {
                padding-right: 1.8em;
            }
            .header > a,
            .floating-close {
                text-decoration: none;
                font-size: 1.5em;
                color: var(--color-primary);
                line-height: 0.75em;
            }
            .floating-close {
                font-size: 2em;
                position: absolute;
                right: 0.5em;
                top: 0.5em;
                z-index: 100;
            }
            .content {
                padding: 1em;
            }
        `;
    }
    render() {
        return html `
            <div>
                ${this.visible
            ? html `
                          <div
                              class="modal ${`size-${this.size}`} ${`overflow-${this.overflow}`} ${this.height !== ''
                ? `height-${this.height}`
                : ''}"
                          >
                              ${!this.hideHeader
                ? html `
                                        <div class="header">
                                            <span>${this.title}</span>
                                            ${!this.cannotBeClosed && !this.hideCloseButton
                    ? html `
                                                      <a
                                                          href="#"
                                                          @click="${(e) => {
                        e.preventDefault();
                        this.close();
                    }}"
                                                          >&#10005;</a
                                                      >
                                                  `
                    : ''}
                                        </div>
                                    `
                : html `
                                        ${!this.cannotBeClosed && !this.hideCloseButton
                    ? html `
                                                  <a
                                                      href="#"
                                                      class="floating-close"
                                                      @click="${(e) => {
                        e.preventDefault();
                        this.close();
                    }}"
                                                      >&#10005;</a
                                                  >
                                              `
                    : ''}
                                    `}
                              <div class="content">
                                  <slot></slot>
                              </div>
                          </div>
                          <div class="overlay" @click="${this.close}"></div>
                      `
            : ''}
            </div>
        `;
    }
    open() {
        this.visible = true;
        this.dispatchEvent(new CustomEvent('opened', { bubbles: true }));
        const body = document.querySelector('body');
        if (body !== null) {
            body.style.top = `-${window.scrollY}px`;
            body.style.position = 'fixed';
            body.style.width = '100%';
            body.style.overflowY = 'scroll';
        }
    }
    close(force) {
        if ((force !== true && this.cannotBeClosed) || !this.visible) {
            return;
        }
        this.visible = false;
        this.dispatchEvent(new CustomEvent('closed', { bubbles: true }));
        const body = document.querySelector('body');
        if (body !== null) {
            const scrollY = document.body.style.top;
            body.style.position = '';
            body.style.top = '';
            body.style.width = '';
            body.style.overflowY = '';
            window.scrollTo(0, parseInt(scrollY || '0') * -1);
        }
    }
};
__decorate([
    property({ type: String })
], TcModal.prototype, "title", void 0);
__decorate([
    property({ type: String })
], TcModal.prototype, "size", void 0);
__decorate([
    property({ type: String })
], TcModal.prototype, "callback", void 0);
__decorate([
    property({ type: Boolean })
], TcModal.prototype, "visible", void 0);
__decorate([
    property({ type: Boolean })
], TcModal.prototype, "cannotBeClosed", void 0);
__decorate([
    property({ type: Boolean })
], TcModal.prototype, "hideCloseButton", void 0);
__decorate([
    property({ type: Boolean })
], TcModal.prototype, "hideHeader", void 0);
__decorate([
    property({ type: String })
], TcModal.prototype, "overflow", void 0);
__decorate([
    property({ type: String })
], TcModal.prototype, "height", void 0);
TcModal = __decorate([
    customElement('tc-modal')
], TcModal);
export default TcModal;
